import React, { useState, useRef } from 'react';
import {
    Grid,
    FormControl,
    Select,
    MenuItem,
    TextField,
    Button,
    Paper,
    Typography,
    Alert,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Container,
    Chip,
    Divider,
    Card,
    CardContent,
    CardHeader
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Save as SaveIcon, Clear as ClearIcon, Send as SendIcon, Assignment as AssignmentIcon, Create as SignatureIcon } from '@mui/icons-material';
import SignatureCanvas from "react-signature-canvas";
import swal from 'sweetalert';
import PDFPreviewDialog from './PDFPreviewDialog';
import { generatePDF } from './calidadPDF';

// Generador de UUID alternativo si crypto.randomUUID no está disponible
function generateUUID() {
    if (window.crypto && window.crypto.randomUUID) {
        return window.crypto.randomUUID();
    }
    // fallback simple
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// --- Styled Components (Premium Glassmorphism) ---

const GlassContainer = styled(Paper)(({ theme }) => ({
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    borderRadius: '24px',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
    padding: theme.spacing(4),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto',
    border: '1px solid rgba(255, 255, 255, 0.18)',
}));

const StyledCard = styled(Card)(({ theme }) => ({
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '16px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
    marginBottom: theme.spacing(4),
    border: '1px solid rgba(0,0,0,0.05)'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    color: '#34495e',
    marginBottom: theme.spacing(2),
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontSize: '1.2rem',
    borderBottom: '2px solid #3f51b5',
    display: 'inline-block',
    paddingBottom: '4px'
}));

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
    backgroundColor: '#f8f9fa',
    color: '#2d3436',
    fontWeight: 700,
    borderBottom: '2px solid #e9ecef',
    textTransform: 'uppercase',
    fontSize: '0.85rem',
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
    fontSize: '0.9rem',
    borderBottom: '1px solid #f1f3f5',
}));

const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '50px',
    padding: '10px 24px',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    transition: 'all 0.2s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 20px 0 rgba(0,0,0,0.15)',
    },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        borderRadius: '12px',
        transition: 'all 0.3s ease',
        '& fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.1)',
        },
        '&:hover fieldset': {
            borderColor: theme.palette.primary.main,
        },
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main,
            borderWidth: '2px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        },
        '&.Mui-focused': {
            backgroundColor: '#fff',
        }
    },
    '& .MuiInputLabel-root': {
        color: '#546e7a',
        fontWeight: 500,
    },
}));

export default function EvaluationCalidad() {


    const [loading, setLoading] = useState(false);
    const [codigoInternoProveedor, setCodigoInternoProveedor] = useState(localStorage.Proveedor);
    const [nombreProveedor, setNombreProveedor] = useState(localStorage.Tproveedor);
    const [tipoDocumento, setTipoDocumento] = useState('NIT');
    const [numeroDocumento, setNumeroDocumento] = useState(localStorage.Nit);
    const [direccion, setDireccion] = useState(localStorage.Direcc);
    const [prestadorBienesServicios, setPrestadorBienesServicios] = useState('');
    const [evaluador, setEvaluador] = useState('');
    const [cargo, setCargo] = useState('');
    const [categoria, setCategoria] = useState(localStorage.Categoria);
    const [fechaEvaluacion, setFechaEvaluacion] = useState('');
    const [periodoEvaluado, setPeriodoEvaluado] = useState('');
    const [correoProveedor, setCorreoProveedor] = useState(localStorage.Email);
    const sigPad = useRef({});
    const sigPad2 = useRef({});
    const [firmaFile, setFirmaFile] = useState(null); // Puede ser base64 o URL
    const [firmaFile2, setFirmaFile2] = useState(null);
    const [firmaFileLoading, setFirmaFileLoading] = useState(false);
    const [firmaFileError, setFirmaFileError] = useState(null);
    const [observacion, setObservacion] = useState('');
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfBase64, setPdfBase64] = useState('');
    const [showPdfPreview, setShowPdfPreview] = useState(false);

    const [responsableVisita, setResponsableVisita] = useState('');
    const [responsableRecibir, setResponsableRecibir] = useState('');

    const handleCodigoInternoProveedorChange = (event) => {
        setCodigoInternoProveedor(event.target.value);
    };

    const handleNombreProveedorChange = (event) => {
        setNombreProveedor(event.target.value);
    };

    const handleTipoDocumentoChange = (event) => {
        setTipoDocumento(event.target.value);
    };

    const handleNumeroDocumentoChange = (event) => {
        setNumeroDocumento(event.target.value);
    };

    const handleDireccionChange = (event) => {
        setDireccion(event.target.value);
    };

    const handlePrestadorBienesServiciosChange = (event) => {
        setPrestadorBienesServicios(event.target.value);
    };

    const handleEvaluadorChange = (event) => {
        setEvaluador(event.target.value);
    };

    const handleCargoChange = (event) => {
        setCargo(event.target.value);
    };

    const handleCategoriaChange = (event) => {
        setCategoria(event.target.value);
    };

    const handleFechaEvaluacionChange = (event) => {
        setFechaEvaluacion(event.target.value);
    };

    const handlePeriodoEvaluadoChange = (event) => {
        setPeriodoEvaluado(event.target.value);
    };

    const handleCorreoProveedorChange = (event) => {
        setCorreoProveedor(event.target.value);
    };

    const handleObservacionChange = (event) => {
        setObservacion(event.target.value);
    };



    const evaluationData = [
        {
            "category": "CALIDAD DEL BIEN Y/O SERVICIO",
            "questions": [
                {
                    "question": "¿¿Cumple con el objeto de la orden de compra?",
                    "index": 0
                },
                {
                    "question": "¿La calidad de las especificaciones del bien, producto o servicio cumple con lo requerido?",
                    "index": 1
                },
                {
                    "question": "¿Cumplimiento al 100% en la entrega de las cantidades requeridas? 1: No cumple 3: Cumple",
                    "index": 2
                },
                {
                    "question": "¿Tiempo de respuesta a las garantías y reclamos? Demorado:1 Intermedio: 2  Ágil:3",
                    "index": 3
                },
                {
                    "question": "¿Índice de reclamos y rechazos? Alto:1  Medio:2 Bajo: 3",
                    "index": 4
                }
            ]
        },
        {
            "category": "COMERCIALES",
            "questions": [
                {
                    "question": "¿Forma de pago? Contado = 1 16-30 días = 2 31 días en adelante = 3",
                    "index": 5
                },
                {
                    "question": "¿Competitividad en el costo total de adquisición (precios, valor agregado, entregas, fletes, recombras, Costos adicionales por envíos, etc.)?",
                    "index": 6
                },
                {
                    "question": "¿Flexibilidad del proveedor? (Pedidos mínimos/ Manejo de urgencias)",
                    "index": 7
                },
                {
                    "question": "Innovación (Propuestas de mejora en la competitividad, actualizaciones tecnológicas, conectividad, seguimiento proactivo a las entregas)",
                    "index": 8
                }
            ]
        },
        {
            "category": "OPORTUNIDAD EN LA RESPUESTA A LOS REQUERIMIENTOS",
            "questions": [
                {
                    "question": "¿El proveedor brinda respuestas oportunas a las cotizaciones, proformas, inquietudes, asesorías y/o consultas en general? SI:3  PARCIAL: 2 No: 1",
                    "index": 9
                }
            ]
        },
        {
            "category": "CUMPLIMIENTO TOTAL DE PEDIDOS ENTREGADOS A TIEMPO",
            "questions": [
                {
                    "question": "¿Cuál es el nivel de cumplimiento con los plazos de entrega? (Calificación: 1 si se encuentra por debajo del 50%, calificación: 2 si se encuentra entre el 51% y el 70%, calificación: 3 del 90% en adelante).",
                    "index": 10
                }
            ]
        },
        {
            "category": "AMBIENTALES",
            "questions": [
                {
                    "question": "¿Cuenta la empresa con un plan de gestión ambiental?",
                    "index": 11
                },
                {
                    "question": "¿Demuestra la empresa el uso de medidas para la reducción de impactos negativos al medio ambiente, como la medición de huella de carbono, huella hídrica, reciclaje, reúso, retomas de materiales de empaque y embalaje, y control de vertimientos? ¿Cuenta con certificaciones ambientales? (Calificación: 3 si cumple con todos los aspectos mencionados, calificación: 2 si cumple parcialmente, calificación: 1 si no cumple).",
                    "index": 12
                }
            ]
        },
        {
            "category": "PSICOSOCIALES",
            "questions": [
                {
                    "question": "¿Cuenta la empresa con planes para la gestión y control de riesgos psicosociales, riesgos laborales, seguridad y salud en el trabajo? (Calificación: 3 si cuenta con planes completos, calificación: 2 si cuenta con planes parciales, calificación: 1 si no cuenta con planes).",
                    "index": 13
                },
                {
                    "question": "¿Se incentivan las actividades de voluntariado, obras sociales y apoyo a fundaciones?",
                    "index": 14
                },
                {
                    "question": "¿Qué beneficios se otorgan a los colaboradores? (Salarios justos, incentivos educativos, economicos, sociales, entre otros)",
                    "index": 15
                }
            ]
        },
        {
            "category": "NEGOCIOS CONFIABLES",
            "questions": [
                {
                    "question": "¿Cuenta la empresa con un código de ética y conducta que aplique a empleados, proveedores, accionistas y otros? (Calificación: 3 si cuenta con un código completo, calificación: 2 si cuenta con un código parcial, calificación: 1 si no cuenta con un código).",
                    "index": 16
                }
            ]
        },
        {
            "category": "DOCUMENTACIÓN DEL PROVEEDOR",
            "questions": [
                {
                    "question": "¿Cumple la empresa con las políticas internas de compras de TALSA y suministra la documentación requerida en la selección, evaluación y seguimiento de proveedores? (Calificación: 3 si los documentos están completos, calificación: 2 si los documentos están incompletos, calificación: 1 si no se suministra la documentación)",
                    "index": 17
                }
            ]
        },
        {
            "category": "SERVICIOS POST VENTA",
            "questions": [
                {
                    "question": "¿Cumple la empresa con las promesas de nivel de servicio, como: respaldo, garantías, reposición de productos o servicios, y brinda asesorías y formaciones? (Calificación: 3 si cumple con todas las promesas, calificación: 2 si cumple parcialmente, calificación: 1 si no cumple).",
                    "index": 18
                },
                {
                    "question": "¿La empresa demuestra proactividad y realiza un seguimiento oportuno en las entregas y cobertura del servicio a nivel nacional, incluyendo las sedes de TALSA? (Calificación: 3 si es proactiva y realiza un seguimiento oportuno, calificación: 2 si es parcialmente proactiva, calificación: 1 si no cumple con la proactividad y seguimiento oportuno).",
                    "index": 19
                }
            ]
        }];

    const asociados = [
        { tipo: 'FAVORABLE', puntaje: '> 80', accion: 'Resaltar los puntos fuertes para reforzar la posición actual y los aspectos destacables que demuestran el buen desempeño.', control: 'No requiere verificación' },
        {
            tipo: 'FAVORABLE CONDICIONAL', puntaje: '> 60 y <= 80', accion: 'Identificar los puntos de mejora para que se implementen acciones correctivas que evidencien la superación de dichas debilidades. Se programará una nueva evaluación en un plazo máximo de 6 meses.',
            control: 'Se realizará una verificación eventual a los tres meses para evaluar el desempeño y cumplimiento del proveedor.'
        },
        {
            tipo: 'NO FAVORABLE', puntaje: '> 0 y <= 60', accion: 'Comunicar al proveedor que no ha cumplido con los parámetros esperados para mantener la continuidad de sus servicios. Esta evaluación es considerada NO FAVORABLE.',
            control: 'Estudiar los planes de acción enviados por el proveedor'
        },
    ];

    const [evaluations, setEvaluations] = useState(Array(20).fill(0));

    const handleEvaluationChange = (index, value) => {
        setEvaluations((prevEvaluations) => {
            const newEvaluations = [...prevEvaluations];
            newEvaluations[index] = value;
            return newEvaluations;
        });
    };

    const [totalPoints, setTotalPoints] = useState(0);

    const sumPoints = () => {
        const sum = evaluations.reduce((total, evaluation) => total + evaluation, 0);
        setTotalPoints(sum);
    };

    const handleClick = () => {
        try {
            setLoading(true);

            // Validation: Check required fields
            const camposRequeridos = [
                { campo: 'codigoProveedor', valor: codigoInternoProveedor, mensaje: 'Código interno del proveedor' },
                { campo: 'nombreProveedor', valor: nombreProveedor, mensaje: 'Nombre del proveedor' },
                { campo: 'tipoDocumento', valor: tipoDocumento, mensaje: 'Tipo de documento' },
                { campo: 'numeroDocumento', valor: numeroDocumento, mensaje: 'Número de documento' },
                { campo: 'direccion', valor: direccion, mensaje: 'Dirección' },
                { campo: 'correoProveedor', valor: correoProveedor, mensaje: 'Correo electrónico del proveedor' },
                { campo: 'prestadorBienesServicios', valor: prestadorBienesServicios, mensaje: 'Prestador de bienes/servicios' },
                { campo: 'categoria', valor: categoria, mensaje: 'Categoría' },
                { campo: 'evaluador', valor: evaluador, mensaje: 'Evaluador' },
                { campo: 'cargo', valor: cargo, mensaje: 'Cargo' },
                { campo: 'responsableVisita', valor: responsableVisita, mensaje: 'Nombre del Responsable' },
                { campo: 'fechaEvaluacion', valor: fechaEvaluacion, mensaje: 'Fecha de Evaluación' },
                { campo: 'periodoEvaluado', valor: periodoEvaluado, mensaje: 'Período Evaluado' }
            ];

            for (let campo of camposRequeridos) {
                if (!campo.valor || campo.valor.trim() === '') {
                    swal({
                        title: 'Campos faltantes',
                        text: `Falta diligenciar: ${campo.mensaje}`,
                        icon: 'warning',
                    });
                    setLoading(false);
                    return false;
                }
            }

            if (firmaFile == null) {
                swal("Firma requerida", "Debe firmar y guardar la firma antes de enviar.", "warning");
                setLoading(false);
                return;
            }

            // Perform points summation to ensure totalPoints is updated
            const currentTotalPoints = evaluations.reduce((total, e) => total + (e || 0), 0);
            const maxPoints = evaluations.length * 3;
            const percentageString = `${((currentTotalPoints / maxPoints) * 100).toFixed(2)}%`;

            // Date parsing
            const dateParts = fechaEvaluacion.split('-');
            const year = dateParts[0];
            const month = dateParts[1];
            const day = dateParts[2];

            // Construct Payload
            const appScriptData = {
                "codigoproveedor": codigoInternoProveedor,
                "nombreproveedor": nombreProveedor,
                "tipodocumento": tipoDocumento,
                "numerodocumento": numeroDocumento,
                "direccion": direccion,
                "prestadorbienes": prestadorBienesServicios,
                "evaluador": evaluador,
                "dia": day,
                "mes": month,
                "ano": year,
                "evaluacionperiodo": periodoEvaluado,
                "correoelectronicoproveedor": correoProveedor,
                "categoria": categoria,
                "variablecargo": cargo,
                "calificacion": percentageString,
                "puntosobtenidos": currentTotalPoints.toString(),
                "puntosposibles": maxPoints.toString(),
                "preguntasaplicables": evaluations.length.toString(),
                "observaciones": observacion,
                "responsabledeevaluar": responsableVisita,
                "firma1": firmaFile,
            };

            // Map all questions as 'pregunta' matching the required structure
            let qNum = 1;
            evaluationData.forEach(category => {
                category.questions.forEach(question => {
                    const idx = question.index;
                    appScriptData[`pregunta${qNum}`] = evaluations[idx] ? evaluations[idx].toString() : "";
                    qNum++;
                });
            });


            const appScriptUrl = "https://script.google.com/macros/s/AKfycbwD_EIrClMktx-tlzPE98LYy-MsOUvZUMoaaxLXq8eWQhoJbXiiQ3zsKafTzvjVFdkK/exec";

            fetch(appScriptUrl, {
                method: 'POST',
                headers: {
                    "Content-Type": "text/plain;charset=utf-8"
                },
                body: JSON.stringify(appScriptData)
            })
                .then(response => response.json())
                .then(result => {
                    setLoading(false);
                    console.log("Respuesta del servidor:", result);

                    // Mostrar mensaje de éxito
                    swal("Exitoso", "Evaluación enviada correctamente", "success");

                    // Extraer la URL del PDF de la respuesta
                    if (result && result.pdf && result.pdf.url) {
                        console.log("📄 URL del PDF recibida:", result.pdf.url);
                        setPdfUrl(result.pdf.url);

                        // Preparar datos para generatePDF (mapeo similar al de FuncionPDF)
                        const tableDataPDF = evaluationData.map(category => ({
                            category: category.category,
                            questions: category.questions.map(q => ({
                                question: q.question,
                                evaluation: evaluations[q.index] || 0
                            }))
                        }));

                        generatePDF(tableDataPDF, ((currentTotalPoints / maxPoints) * 100).toFixed(2), firmaFile, codigoInternoProveedor, nombreProveedor, tipoDocumento, numeroDocumento, direccion, prestadorBienesServicios,
                            evaluador, cargo, categoria, fechaEvaluacion, periodoEvaluado, correoProveedor, responsableVisita, observacion, null, responsableRecibir, false).then(base64 => {
                                setPdfBase64(base64);
                                setShowPdfPreview(true);
                            }).catch(err => {
                                console.error("Error al generar PDF local:", err);
                                setShowPdfPreview(true);
                            });
                    } else {
                        console.warn("⚠️ No se recibió URL del PDF en la respuesta");
                    }
                })
                .catch(e => {
                    console.error("Error App Script:", e);
                    setLoading(false);
                    swal("Error", "No se pudo enviar la evaluación", "error");
                });


        } catch (error) {
            console.error('Error:', error.message);
            setLoading(false);
        }
    };

    return (
        <GlassContainer elevation={3}>
            <Box sx={{ textAlign: "center", mb: 4 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#1a237e' }}>
                    EVALUACIÓN DE CALIDAD PROVEEDORES
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                    Gestión de Calidad
                </Typography>
            </Box>

            {/* Module 1: General Information */}
            <StyledCard elevation={0}>
                <CardHeader
                    title={<SectionTitle>Información General</SectionTitle>}
                    avatar={<AssignmentIcon color="primary" />}
                    sx={{ pb: 0 }}
                />
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="CÓDIGO INTERNO DEL PROVEEDOR"
                                fullWidth
                                required
                                value={codigoInternoProveedor}
                                onChange={handleCodigoInternoProveedorChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="NOMBRE DEL PROVEEDOR"
                                fullWidth
                                required
                                value={nombreProveedor}
                                onChange={handleNombreProveedorChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <StyledTextField
                                    select
                                    label="TIPO DE DOCUMENTO"
                                    required
                                    value={tipoDocumento}
                                    onChange={handleTipoDocumentoChange}
                                >
                                    <MenuItem value="NIT">NIT</MenuItem>
                                    <MenuItem value="CEDULA">CEDULA</MenuItem>
                                    <MenuItem value="RUT">RUT</MenuItem>
                                </StyledTextField>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="NÚMERO DE DOCUMENTO"
                                fullWidth
                                required
                                value={numeroDocumento}
                                onChange={handleNumeroDocumentoChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="DIRECCIÓN"
                                fullWidth
                                required
                                value={direccion}
                                onChange={handleDireccionChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="PRESTADOR DE BIENES O SERVICIOS"
                                fullWidth
                                required
                                value={prestadorBienesServicios}
                                onChange={handlePrestadorBienesServiciosChange}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="EVALUADOR"
                                fullWidth
                                required
                                value={evaluador}
                                onChange={handleEvaluadorChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="CARGO"
                                fullWidth
                                required
                                value={cargo}
                                onChange={handleCargoChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="CATEGORÍA A LA QUE PERTENECE"
                                fullWidth
                                required
                                value={categoria}
                                onChange={handleCategoriaChange}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="FECHA DE EVALUACIÓN"
                                type="date"
                                fullWidth
                                required
                                value={fechaEvaluacion}
                                onChange={handleFechaEvaluacionChange}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="PERÍODO EVALUADO"
                                fullWidth
                                required
                                value={periodoEvaluado}
                                onChange={handlePeriodoEvaluadoChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <StyledTextField
                                label="CORREO ELECTRÓNICO DEL PROVEEDOR"
                                fullWidth
                                value={correoProveedor}
                                onChange={handleCorreoProveedorChange}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>


            <TableContainer component={Paper} elevation={0} sx={{ mb: 4, borderRadius: 2, border: '1px solid #e0e0e0' }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <StyledTableCellHead colSpan={2} align="center">SISTEMA DE PUNTUACIÓN</StyledTableCellHead>
                        </TableRow>
                        <TableRow>
                            <StyledTableCellHead align="center" width="20%">Puntaje</StyledTableCellHead>
                            <StyledTableCellHead align="center">Descripción</StyledTableCellHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <StyledTableCellBody align="center">1</StyledTableCellBody>
                            <StyledTableCellBody align="center">No cumple</StyledTableCellBody>
                        </TableRow>
                        <TableRow>
                            <StyledTableCellBody align="center">2</StyledTableCellBody>
                            <StyledTableCellBody align="center">Cumple parcialmente</StyledTableCellBody>
                        </TableRow>
                        <TableRow>
                            <StyledTableCellBody align="center">3</StyledTableCellBody>
                            <StyledTableCellBody align="center">Cumple</StyledTableCellBody>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Container>
                <TableContainer component={Paper} elevation={0} sx={{ maxHeight: "600px", maxWidth: "100%", overflowY: "auto", border: '1px solid #e0e0e0', borderRadius: 2, mb: 4 }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <StyledTableCellHead>Categoría</StyledTableCellHead>
                                <StyledTableCellHead>Preguntas</StyledTableCellHead>
                                <StyledTableCellHead align="center">Evaluación</StyledTableCellHead>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {evaluationData.map((category, categoryIndex) => (
                                <React.Fragment key={categoryIndex}>
                                    {category.questions.map((question, questionIndex) => (
                                        <TableRow key={`${categoryIndex}-${questionIndex}`}>
                                            {questionIndex === 0 && (
                                                <StyledTableCellBody
                                                    sx={{ fontWeight: 'bold', backgroundColor: '#fafafa', borderRight: '1px solid #eee' }}
                                                    rowSpan={category.questions.length}
                                                >
                                                    {category.category}
                                                </StyledTableCellBody>
                                            )}
                                            <StyledTableCellBody sx={{ width: '50%' }}>
                                                {question.question}
                                            </StyledTableCellBody>
                                            <StyledTableCellBody align="center">
                                                <Select
                                                    value={evaluations[question.index] || ''}
                                                    onChange={(event) => handleEvaluationChange(question.index, event.target.value)}
                                                    sx={{ minWidth: 120, height: 40 }}
                                                    displayEmpty
                                                >
                                                    <MenuItem value="" disabled>Seleccione...</MenuItem>
                                                    <MenuItem value={1}>1 (No cumple)</MenuItem>
                                                    <MenuItem value={2}>2 (Parcial)</MenuItem>
                                                    <MenuItem value={3}>3 (Cumple)</MenuItem>
                                                </Select>
                                            </StyledTableCellBody>
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Container>



            {/* Observations */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h6" gutterBottom color="textSecondary">Observaciones Generales</Typography>
                <StyledTextField
                    fullWidth
                    multiline
                    rows={4}
                    value={observacion}
                    onChange={handleObservacionChange}
                    variant="outlined"
                    placeholder="Ingrese observaciones generales sobre la evaluación..."
                />
            </Box>


            {/* Module 2: Evaluation Results */}
            <StyledCard elevation={0}>
                <CardHeader
                    title={<SectionTitle>Resultados de la Evaluación</SectionTitle>}
                    sx={{ pb: 0 }}
                />
                <CardContent>
                    <Typography style={{ fontWeight: "bold", color: "red", marginBottom: '16px' }}>
                        Nota: Todos los númerales que contengan observaciones deberán contar con un plan de acción, el cual debe de ser documentado en los próximos tres(3) meses
                    </Typography>
                    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0', borderRadius: 2 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCellHead>Calificación</StyledTableCellHead>
                                    <StyledTableCellHead>Puntaje</StyledTableCellHead>
                                    <StyledTableCellHead>Acción a seguir</StyledTableCellHead>
                                    <StyledTableCellHead>Control</StyledTableCellHead>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {asociados.map((asociado, index) => (
                                    <TableRow key={index} hover>
                                        <StyledTableCellBody sx={{ fontWeight: 'bold' }}>{asociado.tipo}</StyledTableCellBody>
                                        <StyledTableCellBody>{asociado.puntaje}</StyledTableCellBody>
                                        <StyledTableCellBody>{asociado.accion}</StyledTableCellBody>
                                        <StyledTableCellBody>{asociado.control}</StyledTableCellBody>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box sx={{ mt: 3, p: 2, bgcolor: '#e8f5e9', borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Typography variant="h6" color="success.dark" gutterBottom>
                            CALIFICACIÓN FINAL: <strong>{((totalPoints / (evaluations.length * 3)) * 100).toFixed(2)} %</strong>
                        </Typography>
                        <Chip
                            label={
                                (((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) > 80 ? "FAVORABLE" : ((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) > 60
                                    && ((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) <= 80 ? "FAVORABLE CONDICIONAL" : "NO FAVORABLE")
                            }
                            color={
                                (((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) > 80 ? "success" : ((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) > 60
                                    && ((totalPoints / (evaluations.length * 3)) * 100).toFixed(2) <= 80 ? "warning" : "error")
                            }
                            sx={{ fontWeight: 'bold', fontSize: '1rem', px: 2 }}
                        />
                    </Box>
                </CardContent>
            </StyledCard>

            {/* Module 3: Signatures */}
            <StyledCard elevation={0} sx={{ border: '1px solid #bbdefb' }}>
                <CardHeader
                    title={<SectionTitle>Firmas y Aprobación</SectionTitle>}
                    avatar={<SignatureIcon color="primary" />}
                />
                <CardContent>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} md={8}>
                            <Paper elevation={0} sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#fafafa' }}>
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom color="primary">
                                    RESPONSABLE DE EJECUTAR LA EVALUACIÓN
                                </Typography>
                                <StyledTextField
                                    label='Nombre del Responsable'
                                    fullWidth
                                    variant="standard"
                                    sx={{ mb: 3, maxWidth: 400 }}
                                    value={responsableVisita}
                                    onChange={(e) => setResponsableVisita(e.target.value)}
                                />
                                <Box sx={{ border: '2px solid #bdbdbd', borderRadius: 1, overflow: 'hidden', bgcolor: '#fff' }}>
                                    <SignatureCanvas
                                        canvasProps={{
                                            width: 500,
                                            height: 180,
                                            className: 'sigCanvas',
                                        }}
                                        ref={sigPad}
                                    />
                                </Box>
                                <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                                    <Button variant="outlined" startIcon={<ClearIcon />} color="error" size="small" onClick={() => { sigPad.current.clear(); setFirmaFile(null); setFirmaFileError(null); }}>
                                        Limpiar
                                    </Button>
                                    <Button
                                        variant="contained"
                                        startIcon={<SaveIcon />}
                                        color="primary"
                                        size="small"
                                        disabled={firmaFileLoading}
                                        onClick={async () => {
                                            sumPoints();
                                            setFirmaFileLoading(true);
                                            setFirmaFileError(null);
                                            try {
                                                const canvas = sigPad.current.getCanvas();
                                                const dataUrl = canvas.toDataURL("image/png");
                                                const base64 = dataUrl.split(",")[1];
                                                const nombreArchivo = `firma_${generateUUID()}.png`;
                                                const body = {
                                                    base64: `data:image/png;base64,${base64}`,
                                                    nombreArchivo,
                                                    tipoArchivo: "image/png"
                                                };
                                                const response = await fetch("https://consumos.talsa.com.co/api/talsa/proveedores/img-proveedor", {
                                                    method: "POST",
                                                    headers: {
                                                        "Content-Type": "application/json"
                                                    },
                                                    body: JSON.stringify(body)
                                                });
                                                let result = null;
                                                try {
                                                    result = await response.json();
                                                } catch (jsonErr) {
                                                    setFirmaFileError("Respuesta inválida del servidor. ¿CORS o error de red?");
                                                    console.error("Respuesta no JSON:", jsonErr, response);
                                                    return;
                                                }
                                                console.log("Respuesta firma:", result);
                                                if (result && result.success && result.url) {
                                                    setFirmaFile(result.url);
                                                    swal("Guardado", "Firma guardada", "success");
                                                } else {
                                                    setFirmaFileError("No se pudo guardar la firma. " + (result && result.message ? result.message : "Intente de nuevo."));
                                                    console.error("Error en respuesta firma:", result);
                                                }
                                            } catch (err) {
                                                setFirmaFileError("Error al subir la firma: " + (err && err.message ? err.message : err));
                                                console.error("Error de red al subir firma:", err);
                                            } finally {
                                                setFirmaFileLoading(false);
                                            }
                                        }}
                                    >
                                        {firmaFileLoading ? "Guardando..." : "Guardar Firma"}
                                    </Button>
                                    {firmaFileError && (
                                        <Alert severity="error" sx={{ mt: 1 }}>{firmaFileError}</Alert>
                                    )}
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </CardContent>
            </StyledCard>

            <Alert severity="warning" sx={{ mb: 3 }}>
                Debe firmar el formulario y guardar la firma antes de enviar la información.
            </Alert>

            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <StyledButton
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={handleClick}
                    startIcon={loading ? null : <SendIcon />}
                    size="large"
                >
                    {loading ? "Enviando..." : "Enviar Información"}
                </StyledButton>
            </Box>

            {/* PDF Preview Dialog */}
            <PDFPreviewDialog
                open={showPdfPreview}
                pdfUrl={pdfUrl}
                pdfBase64={pdfBase64}
                onClose={() => setShowPdfPreview(false)}
                title="Vista Previa - Evaluación de Calidad"
                supplierName={nombreProveedor}
                evaluationType="Evaluación de Calidad"
            />

        </GlassContainer>
    );
}
